import Vue from "vue"
import VideoPlayerWidget from "./components/VideoPlayerWidget.vue";
import {getAttributeValue} from '@/shared/filters/utils-filter';
import Vuex from "vuex";
import VideoPlayerWidgetState from "../VideoPlayerWidget/models/video-player-widget-state";
import mutations from "@/apps/VideoPlayerWidget/store/mutations";
import {root} from "@/shared/store";

Vue.config.productionTip = false;

let videoPlayerWidgetEle = document.querySelectorAll('widget-video-player');
if (videoPlayerWidgetEle.length) {
    videoPlayerWidgetEle.forEach(el => {

        let store = new Vuex.Store({
            state: new VideoPlayerWidgetState,
            mutations: mutations,
            modules: {
                root
            }
        })

        new Vue({
            el: el,
            store,
            render(h) {
                return h(VideoPlayerWidget, {
                    slot: this.$el.innerHTML,
                    props: {
                        consentHtml: this.$el.innerHTML,
                        id: getAttributeValue(el, 'id'),
                        playerType: getAttributeValue(el, 'player-type')
                    }
                })
            }
        });
    });
}
